<template>
  <accounting-sync-status
    v-slot="{ open, close }"
    :message="entity!.accounting_message"
    :success="entity!.accounting_success"
  >
    <sync-dialog
      v-model:accounting-success="entity!.accounting_success"
      :accounting-message="entity!.accounting_message"
      :order-owner="orderOwner"
      :order-reference-name="order.reference_name!"
      :po-id="po.id!"
      :po-number="po.po_number!"
      :revision-id="entity!.id"
      :revision-number="revision?.revNumber || po.change_orders.length"
      :show-dialog="open"
      @update:show-dialog="close"
    />
  </accounting-sync-status>
</template>

<script setup lang="ts">
import type { Order, PurchaseOrder, Revision } from '@quotetome/materials-api'
import AccountingSyncStatus from '@/components/accounting/accounting-sync-status.vue'
import SyncDialog from '@/components/purchase-orders/sync-dialog.vue'

interface OrderedRevision extends Revision {
  revNumber: number
}

export interface Props {
  order: Order
  po: PurchaseOrder
  revision?: OrderedRevision
}

const props = defineProps<Props>()

const entity = computed(() => props.revision || props.po.latest_change_order)

const orderOwner = computed(() => `${props.order.owner?.first_name} ${props.order.owner?.last_name}`)
</script>
